module.exports = __webpack_public_path__ + "static/img/pay-1.d6eb48b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pay/pay-1.png
// module id = jWN0
// module chunks = 1